var CookieMgr = (function() {
  var enableLog = false
  var setCookieOnTopLevelDomain = false
  var log = function(msg) {
    if (enableLog && window.console) {
      console.log(msg)
    }
  }

  var getCookieDomain = function(hostname) {
    // strip www
    var domain = hostname.replace('www.', '')
    log('setting cookie on toplevel domain:' + setCookieOnTopLevelDomain)
    //SQ does not like this: if (setCookieOnTopLevelDomain) { domain = domain.replace(/[\w\d\-\.]*\.([\w\d\-]*\.\w{2,3})$/i, '$1') //}
    if (setCookieOnTopLevelDomain) {
      domain = domain.replace(/^[^\.]+\.[^\.]+\.\w{2,3}$/, '$1');
    }
    return domain
  }

  var createCookie = function(name, value, days) {
      var expires = ''
      if (days) {
        var date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = '; expires=' + date.toGMTString()
      }

      if (value === '') {
        // deleting cookies from www-domain, if set
        document.cookie = `${name}=${value}${expires};domain=${window.location.hostname}; path=/`
      }

      var domain = getCookieDomain(window.location.hostname)
      log('setting cookie on ' + domain)
      if (domain === 'localhost') {
        document.cookie = `${name}=${value}${expires}; path=/;SameSite=Lax`
      } else {
        document.cookie = `${name}=${value}${expires};domain=${domain}; path=/;SameSite=Lax`
      }
    },
    readCookie = function(name) {
      var nameEq = name + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length)
        }
        if (c.indexOf(nameEq) === 0) {
          return c.substring(nameEq.length, c.length)
        }
      }
      return null
    },
    eraseCookie = function(name) {
      log('erasing cookie: ' + name)
      createCookie(name, '', -1)
    },
    init = function(opts) {
      log('init cookiemgr:')
      log(opts)
      setCookieOnTopLevelDomain = opts.setCookieOnTopLevelDomain
    }

  return {
    init: init,
    createCookie: createCookie,
    readCookie: readCookie,
    eraseCookie: eraseCookie,
    getCookieDomain: getCookieDomain
  }
})()

export const PiwikProTracker = (function() {
  'use strict'
  var cookieMgr = CookieMgr,
    loadAsync = true,
    account,
    piwikProPath,
    params = [],
    fakeAnalytics,
    enableLog = true

  var log = function(msg) {
    if (window.console && enableLog) {
      console.log(msg)
    }
  }

  var eraseCookie = function() {
    log('erasing cookies in piwikpro tracker')
    // known piwik pro cookies
    cookieMgr.eraseCookie(`_pk_id.${account}.1fff`)
    cookieMgr.eraseCookie(`_pk_ses.${account}.1fff`)
    cookieMgr.eraseCookie('stg_last_interaction')
    cookieMgr.eraseCookie('stg_returning_visitor')
    cookieMgr.eraseCookie('stg_traffic_source_priority')
    cookieMgr.eraseCookie('PIWIK_SESSID')
    cookieMgr.eraseCookie('piwik_auth')
    cookieMgr.eraseCookie('_pk_cvar')
    cookieMgr.eraseCookie('stg_popup')
    cookieMgr.eraseCookie('stg_utm_campaign')
    cookieMgr.eraseCookie('stg_externalReferrer')
    cookieMgr.eraseCookie('stg_content')
  }

  var callSetupCode = function(accountPath, accountId) {
    /* jshint ignore:start */
    ;(function(window, document, dataLayerName, id) {
      //Ensures dataLayer exists
      if (!window[dataLayerName]) {
        window[dataLayerName] = [];
      }

      //Push the event to the dataLayer
      window[dataLayerName].push({
        // NOSONAR
        start: new Date().getTime(),
        event: 'stg.start'
      }); // NOSONAR

      //Get first script tag to insert new script
      var scripts = document.getElementsByTagName('script')[0],
          tags = document.createElement('script');

      //Create cookies
      function stgCreateCookie(a, b, c) {
        var d = '';
        if (c) {
          var e = new Date();
          e.setTime(e.getTime() + 24 * c * 60 * 60 * 1e3);
          d = '; expires=' + e.toUTCString();
        }
        document.cookie = a + '=' + b + d + '; path=/';
      }

      //Sets stg_debug cookie, if needed
      var isStgDebug =
          (window.location.href.match('stg_debug') || document.cookie.match('stg_debug')) &&
          !window.location.href.match('stg_disable_debug');
      stgCreateCookie('stg_debug', isStgDebug ? 1 : '', isStgDebug ? 14 : -1);

      //Prepares query parameters for script URL
      var qP = [];
      if (dataLayerName !== 'dataLayer') qP.push('data_layer_name=' + dataLayerName);
      if (isStgDebug) qP.push('stg_debug'); // NOSONAR
      var qPString = qP.length > 0 ? '?' + qP.join('&') : '';

      //Sets script attributes and inserts it into DOM
      tags.async = true;
      tags.src = `//erst.containers.piwik.pro/${id}.js${qPString}`;
      scripts.parentNode.insertBefore(tags, scripts); // NOSONAR

      //Setup ppms, namespaces and functions
      !(function(a, n, i) {
        a[n] = a[n] || {};
        for (var c = 0; c < i.length; c++) {
          !(function(i) {
            a[n][i] = a[n][i] || {};
            a[n][i].api =
                a[n][i].api ||
                function() {
                  var a = [].slice.call(arguments, 0);
                  if (typeof a[0] === 'string') {
                    window[dataLayerName].push({
                      event: `${n}.${i}:${a[0]}`,
                      parameters: [].slice.call(arguments, 1)
                    });
                  }
                };
          })(i[c]);
        }
      })(window, 'ppms', ['tm', 'cm']);
    })(window, document, 'dataLayer', accountId);

    /* jshint ignore:end */
  };

  var injectCode = function(injectCfg) {
    if (account) {
      log('inserting Piwik Pro tracking code')
      callSetupCode(piwikProPath, account)
    }
  }

  var init = function(cfg) {
    loadAsync = cfg.async || true
    params = cfg.params || []
    account = cfg.account
    piwikProPath = cfg.piwikProPath
    fakeAnalytics = cfg.fakeAnalytics
    // if there is a ready() function on the configuration, this will be called.
    if (cfg.ready && typeof cfg.ready === 'function') {
      cfg.ready({
        loadAsync: loadAsync,
        params: params,
        account: account
      })
    }
  }

  return {
    init: init,
    eraseCookie: eraseCookie,
    injectCode: injectCode
  }
})()

// Add a getElementsByClassName function if the browser doesn't have one
// Limitation: only works with one class name
// Copyright: Eike Send http://eike.se/nd
// License: MIT License
if (!document.getElementsByClassName) {
  document.getElementsByClassName = function(search) {
    var d = document,
      elements,
      pattern,
      i,
      results = []
    if (d.querySelectorAll) {
      // IE8
      return d.querySelectorAll('.' + search)
    }
    if (d.evaluate) {
      // IE6, IE7
      pattern = `.//*[contains(concat(' ', @class, ' '), ' ${search} ')]`
      elements = d.evaluate(pattern, d, null, 0, null)
      while ((i = elements.iterateNext())) {
        results.push(i)
      }
    } else {
      elements = d.getElementsByTagName('*')
      pattern = new RegExp(`(^|\\s)${search}(\\s|$)`)
      for (i = 0; i < elements.length; i++) {
        if (pattern.test(elements[i].className)) {
          results.push(elements[i])
        }
      }
    }
    return results
  }
}
export const CookiePrompter = (function() {
  'use strict'

  var config = {} // will get keys from defaults on init

  var log = function(msg) {
    if (config.enableLog && window.console) {
      console.log(msg)
    }
  }

  var NO_TRACK_VAL = 'n',
    OK_TRACK_VAL = 'y',
    TRACKING_COOKIE = 'cookieOptOut',
    trackers = [],
    defaults = {
      // will be copied into config on init
      setCookieOnTopLevelDomain: false,
      expiryDays: 365,
      readMoreUrl: undefined,
      textHeader: 'Vi bruger cookies til at indsamle statistik over brugen af hjemmesiden',
      textblock1:
        'Hvis du klikker på knappen ’Accepter’, godkender du, at vi sætter cookies til brug for statistik.' +
        ' Hvis du klikker på knappen ’Afvis,’ sætter vi ikke cookies til statistik',
      textblock2: ' – vi benytter dog en cookie for at huske dit valg.',
      textNoThanks: '',
      textReadMore: 'Læs mere om cookies her',
      textAccept: 'Accepter',
      textDontAccept: 'Afvis',
      styling: {
        inlinestyle: 'border-bottom:2px solid #000;padding: 12px 20px 0 20px;margin-bottom:12px;',
        inlinestyleInner: 'max-width:960px;margin-left:auto;margin-right:auto;'
      },
      enableLog: false,
      onOptOut: function(pageHref) {
        log('opting out from page: ' + pageHref)
      },
      onReady: function(cfg) {
        log('config.onReady()')
      },
      cookieMgr: CookieMgr
    }

  var removePrompt = function() {
    if (typeof Element.prototype.remove == 'undefined') {
      Element.prototype.remove = function() {
        this.parentElement.removeChild(this)
      }
    }

    var el = document.getElementById('eksCookiePrompt')
    if (el) {
      el.parentNode.remove()
    }
  }

  var setNoTrackingCookie = function() {
    config.cookieMgr.eraseCookie(TRACKING_COOKIE)
    config.cookieMgr.createCookie(TRACKING_COOKIE, NO_TRACK_VAL, config.expiryDays)
  }

  var insertTrackingCode = function(cfg) {
    log(`inserting tracking code for ${trackers.length} trackers`)
    for (var i = 0; i < trackers.length; i++) {
      var t = trackers[i]
      t.injectCode(cfg)
    }
  }

  var acceptBtnClick = function() {
    config.cookieMgr.createCookie(TRACKING_COOKIE, OK_TRACK_VAL, config.expiryDays)
    insertTrackingCode()
    removePrompt()
    return false
  }

  // erasing cookies in all trackers
  var eraseCookies = function() {
    log('deleting cookies')
    for (var i = 0; i < trackers.length; i++) {
      log('deleting for ' + trackers[i])
      trackers[i].eraseCookie()
    }
  }

  // erasing cookies and setting dont-track cookie
  var removeCookies = function() {
    eraseCookies()
    setNoTrackingCookie()
  }

  var eraseCookiesAndRemovePrompt = function() {
    log('eraseCookiesAndRemovePrompt()')
    removeCookies()
    removePrompt()
    if (config.onOptOut && typeof config.onOptOut === 'function') {
      log('firing onOptOut callback')
      config.onOptOut(window.location.href)
    }
    return false
  }

  var bindAcceptCookiesBtn = function() {
    log('bindAcceptCookiesBtn()')
    var acceptbtns = document.getElementsByClassName('cpAcceptBtn')
    for (var i = acceptbtns.length - 1; i >= 0; i--) {
      var btn = acceptbtns[i]
      btn.onclick = acceptBtnClick
    }
  }

  var bindDontAcceptCookiesBtn = function() {
    log('bindDontAcceptCookiesBtn()')
    var dontAcceptBtns = document.getElementsByClassName('cpDontAcceptBtn')
    for (var i = dontAcceptBtns.length - 1; i >= 0; i--) {
      var btn = dontAcceptBtns[i]
      btn.onclick = eraseCookiesAndRemovePrompt
    }
  }

  var hookupExplicitBtns = function() {
    log('hookupExplicitBtns()')
    bindAcceptCookiesBtn()
    bindDontAcceptCookiesBtn()
  }

  var renderCookieprompt = function() {
    log('renderCookieprompt()')
    log('  removing prompt')
    removePrompt()

    log('  creating and inserting html')
    var html = []

    html.push(`<div class="cookie-container" id="eksCookiePrompt">
    <div class="cookie-message">
      <div class="cookie-text">
        <h2 class="h3 mt-0 mb-3">${config.textHeader}</h2>
        <p class="mt-0">
        ${config.textblock1} <a href="${config.readMoreUrl}">${config.textReadMore}</a>
        </p>
      </div>
      <div class="cookie-actions">
        <ul class="inline-list">
          <li>
            <a href="#" class="button button-secondary cpAcceptBtn">${config.textAccept}</a>
          </li>
          <li>
            <a href="#" class="ml-md-4 button button-tertiary cpDontAcceptBtn"
              >${config.textDontAccept}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>`)

    /*     if (config.styling.cssclass) {
          html.push(
            '<div class="' + config.styling.cssclass + '" id="eksCookiePrompt">'
          );
          html.push('<div id="eksCookiePromptInner">');
        } else {
          html.push(
            '<div style="' + config.styling.inlinestyle + '" id="eksCookiePrompt">'
          );
          html.push(
            '<div id="eksCookiePromptInner" style="' +
              config.styling.inlinestyleInner +
              '">'
          );
        }
        html.push("<strong>" + config.textHeader + "</strong>");
        html.push("<p>" + config.textblock1);
        html.push('<a href="#" id="eksCookieNo">' + config.textNoThanks + "</a>");
        html.push(config.textblock2 + "</p>");
    
        if (config.readMoreUrl && document.location.hash !== "#cookieprompt") {
          html.push(
            '<p><a href="' +
              config.readMoreUrl +
              '#cookieprompt">' +
              config.textReadMore +
              "</a></p>"
          );
        }
    
        html.push(
          '<div class="cpButtons"><a href="#" class="cpAcceptBtn">' +
            config.textAccept +
            "</a>"
        );
        if (config.textDontAccept !== "") {
          html.push(
            '<a href="#" class="cpDontAcceptBtn">' + config.textDontAccept + "</a>"
          );
        }
        html.push("</div>");
    
        html.push("</div></div>"); */
    var body = document.getElementsByTagName('body')[0]
    var block = document.createElement('div')
    block.className = 'eksCookieContainer'
    block.innerHTML = html.join('')
    body.insertBefore(block, body.firstChild)
    var link = document.getElementById('eksCookieNo')
    if (link) {
      link.onclick = eraseCookiesAndRemovePrompt
    }

    hookupExplicitBtns()
  }

  var init = function(opts) {
    log('init()')

    // merge defaults into config
    for (var k in defaults) {
      config[k] = defaults[k]
    }

    // merge supplied overrides into config
    for (var j in opts) {
      config[j] = opts[j]
    }

    config.cookieMgr.init({
      setCookieOnTopLevelDomain: config.setCookieOnTopLevelDomain
    })

    trackers = []
    if (opts.trackers) {
      for (var i = 0; i < opts.trackers.length; i++) {
        var tracker = opts.trackers[i].name
        log(tracker)
        var trackerConfig = opts.trackers[i].config
        tracker.init(trackerConfig)
        trackers.push(tracker)
      }
    } else {
      log('  no trackers added. You would probably want at least one.')
    }

    // read more page
    if (document.location.hash === '#cookieprompt') {
      renderCookieprompt()
      return
    }

    // check for cookie
    var cookie = config.cookieMgr.readCookie(TRACKING_COOKIE)
    log('  tracking cookie found: ' + cookie)

    if (cookie === NO_TRACK_VAL) {
      log('  a) disabletracking cookie found. Not tracking')
      eraseCookies()
    } else {
      if (cookie === OK_TRACK_VAL) {
        log('  b) ok cookie found, tracking accepted, we are tracking')
        insertTrackingCode()
      } else {
        log('  rendering prompt because explicit (no cookie)')
        renderCookieprompt()
      }
    }

    config.onReady(config)
  }

  // get the optout cookie
  var getCookie = function() {
    return config.cookieMgr.readCookie(TRACKING_COOKIE)
  }

  return {
    init: init,
    removeCookies: removeCookies,
    removePrompt: removePrompt,
    eraseCookiesAndRemovePrompt: eraseCookiesAndRemovePrompt,
    getCookie: getCookie
  }
})()
